import { render, staticRenderFns } from "./RoomItem.vue?vue&type=template&id=06eecfb0&"
import script from "./RoomItem.vue?vue&type=script&lang=js&"
export * from "./RoomItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports